import { TemplateConfig } from '../template-config.interface';
import {
  disneyAvailableNow,
  disneyCTV,
  disneyEspnRugbyUrbaMiniatura,
  disneySeasonality,
  disneySocialThisMonth,
  disneyRelated,
  disneySocialTop,
  disneyCast,
  disneyGrid,
  disneyBinge,
  disneyBestPlan,
  disneyEspnVS,
  disneyEspnPlayerVSPlayer
} from '../DISNEY/';

import { resumidoCarouselGenerico, resumidoCarouselManoAMano } from '../RESUMIDO';

import { GPOVALLASAutoResolution, GPOVALLASAutoResolutionBranded } from '../GPOVALLAS';

import { macroCTV } from '../MACRO';

export const TEST_TEMPLATES: TemplateConfig[] = [
  { ...macroCTV, clientId: 'TEST' },
  { ...disneyAvailableNow, clientId: 'TEST' },
  { ...disneyCTV, clientId: 'TEST' },
  { ...disneySeasonality, clientId: 'TEST' },
  { ...resumidoCarouselGenerico, clientId: 'TEST' },
  { ...resumidoCarouselManoAMano, clientId: 'TEST' },
  { ...disneyEspnRugbyUrbaMiniatura, clientId: 'TEST' },
  { ...disneyEspnPlayerVSPlayer, clientId: 'TEST' },

  // No disponibles
  { ...disneySocialThisMonth, clientId: 'TEST' },
  { ...disneyRelated, clientId: 'TEST' },
  { ...disneyEspnVS, clientId: 'TEST' },
  { ...disneySocialTop, clientId: 'TEST' },
  { ...disneyCast, clientId: 'TEST' },
  { ...disneyGrid, clientId: 'TEST' },
  { ...disneyBinge, clientId: 'TEST' },
  { ...disneyBestPlan, clientId: 'TEST' },

  { ...GPOVALLASAutoResolutionBranded, clientId: 'TEST' },
  { ...GPOVALLASAutoResolution, clientId: 'TEST' }
];
